import styled from "styled-components";

export const StyledContainer = styled("div")<{ border?: boolean }>`
  position: relative;
  width: 100%;
  max-width: var(--page-width);
  margin-right: auto;
  margin-left: auto;
  padding: 0 32px;
  border-top: ${(p) => (p.border ? "1px solid var(--border-color)" : "")};

  @media only screen and (max-width: 1024px) {
    max-width: 100%;
    padding: 0 24px;
  }

  @media only screen and (max-width: 768px) {
    max-width: 100%;
    padding: 0 20px;
  }

  @media only screen and (max-width: 414px) {
    max-width: 100%;
    padding: 0 18px;
  }
`;
